import React from "react";
import {
  Button,
  Edit,
  ShowProps,
  SimpleForm,
  Toolbar,
  useMutation,
  useNotify,
  useRefresh,
} from "react-admin";
import { Grid, makeStyles } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { useFormState } from "react-final-form";
import SaveIcon from "@material-ui/icons/Save";
import RichTextInput from "ra-input-rich-text";

interface IUpdateNoteButton {
  studentId: number;
}

const SaveButton = ({ studentId }: IUpdateNoteButton) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const { values } = useFormState();

  const [handleUpdateNoteStudent, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `students/${studentId}/note`,
      payload: {
        data: {
          StudentId: Number(studentId),
          Note: values.internalNote?.value,
        },
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully update note student.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed update note the student, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleUpdateNoteStudent}
      color="primary"
      label={loading ? "Please wait..." : "Save"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const useStyles = makeStyles({
  edit: {
    marginTop: -20,
  },
});

const InternalNote = (props: ShowProps) => {
  const classes = useStyles();
  const { id } = props;

  const NoteEditToolbar = (props: any) => (
    <Toolbar {...props}>
      <SaveButton studentId={Number(id)} />
    </Toolbar>
  );

  return (
    <Edit {...props} title=" " actions={null} className={classes.edit}>
      <SimpleForm toolbar={<NoteEditToolbar />}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <RichTextInput label="Internal Note" source="internalNote.value" />
          </Grid>
        </SanitizedGrid>
      </SimpleForm>
    </Edit>
  );
};

export default InternalNote;
